export const cprValidation = (cpr) => {
  cpr = cpr.replace(/-|\s/g, "");
  
  // Ensure the CPR number is 10 digits long
  if (cpr.length !== 10 || isNaN(cpr)) {
    return false;
  }

  // Calculate the checksum using the Modulus 11 rule
  const weights = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
  let checksum = 0;
  for (let i = 0; i < 10; i++) {
    checksum += parseInt(cpr.charAt(i), 10) * weights[i];
  }
  
  // The CPR number is valid if the checksum is divisible by 11
  return checksum % 11 === 0;
  
};

export const worksetValidation = (workset, item) => {
  if(workset.length >= 1){
    
    switch (item) {
      case "area":
        if(workset[0].area == null)
          return false;

        break;

        case "function":
          if(workset[0].function == null)
            return false;
          break;
    }

    return true;
  }
};

export const dateValidation = (date, dateStart, dateEnd, store, visuals, products) => {
  console.log("products.unemploymentinsuranceselected", products.unemploymentinsuranceselected);
  if(dateStart == null)
    return false;

  if(dateEnd == null)
    return false;

  if(!products.unemploymentinsuranceselected)
    return true;

  var dStart = new Date(dateStart); 
  var dEnd = new Date(dateEnd); 
  
  // 18 months * 30 days
  var minimumEducationUnemploymentInsuranceDuration = 18 * 30;

  // To calculate the time difference of two dates 
  var educationDuration = dEnd.getTime() - dStart.getTime(); 
    
  // To calculate the no. of days between two dates 
  var educationDurationDays = educationDuration / (1000 * 3600 * 24);

  if(educationDurationDays > minimumEducationUnemploymentInsuranceDuration){
    store.educationDurationApproved = true;
    //visuals.showEducationProblemModal = false;
  }else{
    store.educationDurationApproved = false;
    //visuals.showEducationProblemModal = true;
  }

  return true;
};

export const dateStartEndValidation = (date, dateStart, dateEnd) => {
  if(dateStart == null)
    return false;

  if(dateEnd == null)
    return false;

  var dStart = new Date(dateStart); 
  var dEnd = new Date(dateEnd); 

  if(dStart >= dEnd)
    return false;

  return true;
};

export const phoneDummyValidation = (value) => {
  const forbiddenValues = [
    "11111111", 
    "22222222", 
    "33333333", 
    "44444444", 
    "55555555", 
    "66666666",
    "77777777",
    "88888888",
    "99999999",
    "00000000",
    "11223344",
    "44332211",
    "01234567",
    "12345678",
    "23456789",
    "34567890"];
  return !forbiddenValues.includes(value);
};